import React from "react";
import { Redirect } from "react-router-dom";
import { Form, Grid } from "semantic-ui-react";
import styled from "styled-components";
import ErrorDisplay from "../components/ErrorDisplay";
import { Paths } from "../Constants";
import dateTimeHelper from "../util/dateTimeHelper";
import { isDobFormatValid } from "../util/regexHelper";
import stringHelper from "../util/stringHelper";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import PillButton from "./common/PillButton";
import SFCookieConsent from "./common/SFCookieConsent";
import SiteWrapper from "./common/SiteWrapper";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const StyledForm = styled(Form)`
  width: 400px;
  margin-top: 80px;
`;

const CenteredButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

class YourInfo extends BaseComponent {
  constructor() {
    super();
    this.state = {
      useBarcode: false,
      barcodeRead: false,
      firstName: null,
      middleName: null,
      lastName: null,
      dob: null,
      postalCode: null,
      formIsValid: false,
      showActivityIndicator: false,
      isOver18: false,
      redirectPath: null,
    };

    this.completeRegistration = this.completeRegistration.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.checkForm = this.checkForm.bind(this);
  }

  isFormValid() {
    this.errorManager.reset();
    if (
      stringHelper.isNullOrEmpty(this.state.firstName) ||
      stringHelper.isNullOrEmpty(this.state.lastName) ||
      stringHelper.isNullOrEmpty(this.state.dob) ||
      stringHelper.isNullOrEmpty(this.state.postalCode)
    ) {
      return false;
    } else {
      //something in there for everything. Start validating.

      //DOB check

      if (this.state.dob !== null && this.state.dob !== "") {
        if (!isDobFormatValid(this.state.dob)) {
          this.errorManager.addError("DOB must be in mm/dd/yyyy format");
          this.forceUpdate();
          return;
        }

        const dbDate = dateTimeHelper.formattedDateToDbDate(this.state.dob);
        if (!dateTimeHelper.isDBDateOverAge(dbDate, 18)) {
          this.errorManager.addError(
            "Users must be at least 18 years of age to use SafeFun"
          );
          this.setState({ isOver18: false });
          return false;
        } else {
          this.setState({ isOver18: true });
        }
      }
      return true;
    }
  }

  checkForm() {
    this.setState({ formIsValid: this.isFormValid() });
  }

  async completeRegistration() {
    if (!(await this.checkLogin())) {
      return;
    }

    this.errorManager.reset();
    let response;
    this.setState({ showActivityIndicator: true });
    try {
      response = await this.safeFunApi.createProfile(
        this.state.firstName,
        this.state.middleName,
        this.state.lastName,
        this.state.dob,
        this.state.postalCode
      );
      this.setState({ showActivityIndicator: false });
      if (response.data && response.data.success) {
        //const permissions = await this.safeFunApi.getPermissions();

        this.setState({ redirectPath: Paths.WELCOME });
        return;
      }
      this.errorManager.addError("There was a problem creating your profile.");
      this.forceUpdate();
    } catch (err) {
      this.setState({ showActivityIndicator: false });
      this.errorManager.addError(
        "There was an error completing your registration."
      );
      this.forceUpdate();
      console.log(err.toString());

      //NEED TO DEAL WITH THIS ERROR BETTER
    }
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
            }}
          />
        ) : null}

        <AppHeaderSmall title="Your Info" />
        <MainContentWrapper>
          <Wrapper>
            <StyledForm>
              <Grid columns={1}>
                <Grid.Row>
                  <Grid.Column style={{ margin: "20px", fontWeight: "bold" }}>
                    Please make sure your name is spelled correctly below. We
                    will use this information to match your test results.
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              <Form.Input
                onChange={(e) => {
                  this.setState({ firstName: e.target.value });
                }}
                onBlur={this.checkForm}
                placeholder="First Name*"
              />
              <Form.Input
                onChange={(e) => {
                  this.setState({ lastName: e.target.value });
                }}
                onBlur={this.checkForm}
                placeholder="Last Name*"
              />
              <Form.Input
                onChange={(e) => {
                  this.setState({ dob: e.target.value });
                }}
                onBlur={this.checkForm}
                placeholder="Date of Birth* (MM/DD/YYYY)"
              />
              <Form.Input
                onChange={(e) => {
                  this.setState({ postalCode: e.target.value });
                }}
                onBlur={this.checkForm}
                placeholder="Postal Code*"
              />
              <Grid columns={1}>
                {this.errorManager.getErrorCount() > 0 ? (
                  <Grid.Row>
                    <Grid.Column>
                      <ErrorDisplay errorManager={this.errorManager} />
                    </Grid.Column>
                  </Grid.Row>
                ) : null}
                <Grid.Row>
                  <Grid.Column>
                    <CenteredButtonWrapper>
                      <PillButton
                        primary
                        style={{ width: "200px" }}
                        onClick={() => this.completeRegistration()}
                        disabled={
                          !this.state.formIsValid || !this.state.isOver18
                        }
                      >
                        Finish
                      </PillButton>
                    </CenteredButtonWrapper>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </StyledForm>
          </Wrapper>
        </MainContentWrapper>
        <Footer />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }
}

export default YourInfo;
